<template>
  <generic-modal
    :title="$t('enterprise manager')"
    ref="generic_modal"
    :is_wide="true"
  >
    <entity-datatable
      @set_as_current="set_enterprise"
      @select_period="set_period"
    />
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  get,
  post,
  generate_error_message_text,
  format_date,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import EntityDatatable from "../entity_datatable/Index.vue";

export default {
  name: "EntityManagerModal",
  components: { GenericModal, EntityDatatable },
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
    },
    set_enterprise(enterprise) {
      let v = this;
      v.$emit("set_as_current", enterprise);
      v.close_modal();
    },
    set_period(data) {
      let v = this;
      v.$emit("set_period", data);
      v.close_modal();
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
